export default "__VITE_ASSET__64c020d5__"